import api from '../../services/api';
export const recordClientAction = (customerId, context, action, extra = {}) =>
  api.post(`/clients/${customerId}/ui-audit`, { ...context, action, ...extra });
export const captureClientButton = (customerId, context) => event => {
  const button = event.target.closest('button');
  if (!button) return;
  recordClientAction(customerId, context, 'button', { control: button.textContent.trim().slice(0, 100) })
    .catch(() => console.warn('No se pudo registrar el boton del formulario.'));
};
export const captureClientCheck = (customerId, context) => event => {
  if (event.target.type !== 'checkbox') return;
  recordClientAction(customerId, context, 'selection', { control: 'checkbox', checked: event.target.checked })
    .catch(() => console.warn('No se pudo registrar la seleccion del formulario.'));
};
